module.exports = __webpack_public_path__ + "static/Spotify-Podcasts-d562abb74656a0221fd21607c1ee6b26.png";